import { adminClient } from './client'
import type {
  AdminMetrics,
  EmailLogEntry,
  PaginatedResponse,
  Post,
  PostCountryViewStat,
  PostFormValues,
  PostsQueryOptions,
  SingleResponse,
} from '../types'

export const adminApi = {
  // ── Posts ──────────────────────────────────────────────────────────────────

  async listPosts(opts: PostsQueryOptions = {}): Promise<PaginatedResponse<Post>> {
    const { q, status = 'all', page = 1, pageSize = 20 } = opts
    const res = await adminClient.get<PaginatedResponse<Post>>('/api/admin/posts', {
      params: { q: q || undefined, status, page, pageSize },
    })
    return res.data
  },

  async getPost(slug: string): Promise<Post> {
    const res = await adminClient.get<SingleResponse<Post>>(`/api/admin/posts/${slug}`)
    return res.data.data
  },

  async upsertPost(values: PostFormValues): Promise<Post> {
    const res = await adminClient.post<SingleResponse<Post>>('/api/admin/posts', values)
    return res.data.data
  },

  async deletePost(slug: string): Promise<void> {
    await adminClient.delete(`/api/admin/posts/${slug}`)
  },

  // ── Metrics ────────────────────────────────────────────────────────────────

  async getMetrics(): Promise<AdminMetrics> {
    const res = await adminClient.get<SingleResponse<AdminMetrics>>('/api/admin/metrics')
    return res.data.data
  },

  async getPostCountryViews(page = 1, pageSize = 10): Promise<PaginatedResponse<PostCountryViewStat>> {
    const res = await adminClient.get<PaginatedResponse<PostCountryViewStat>>(
      '/api/admin/post-country-views',
      { params: { page, pageSize } },
    )
    return res.data
  },

  // ── Email logs ─────────────────────────────────────────────────────────────

  async getEmailLogs(page = 1, pageSize = 50): Promise<PaginatedResponse<EmailLogEntry>> {
    const res = await adminClient.get<PaginatedResponse<EmailLogEntry>>(
      '/api/admin/email-logs',
      { params: { page, pageSize } }
    )
    return res.data
  },

  // ── Notify subscribers ─────────────────────────────────────────────────────

  async notifySubscribers(slug: string): Promise<{ dispatched: number }> {
    const res = await adminClient.post<SingleResponse<{ dispatched: number }>>(
      `/api/admin/posts/${slug}/notify`
    )
    return res.data.data
  },
}
